import React, {memo, Suspense} from 'react';
import { RouteLoader, useUser } from '@dofleini/security';
import PageLoader from '@/components/PageLoader';
import routes from './routes';
import routesPublic from './routes-public';

const MainRouter = () => {
  const { isAuthenticated } = useUser();

  return (
    <Suspense fallback={<PageLoader/>}>
      <RouteLoader routes={!isAuthenticated ? routesPublic : routes} notfoundRedirect={'/'}/>
    </Suspense>
  );
};

export default memo(MainRouter);
